function ModuleCard({ module }) {
  return (
    <article className="rounded-[12px] border border-[#E5E7EB] bg-white p-[16px] md:p-[20px]">
      <div className="flex items-start gap-[12px]">
        <span className="inline-flex h-[36px] min-w-[36px] items-center justify-center rounded-[10px] bg-main-pink text-[14px] font-[700] leading-[100%] text-white">
          {module.number}
        </span>
        <div>
          <h3 className="text-[#0A0A0A] text-[16px] font-[600] leading-[125%]">{module.title}</h3>
          <p className="mt-[4px] text-[#6A7282] text-[13px] md:text-[14px] font-[400] leading-[140%]">
            {module.description}
          </p>
        </div>
      </div>
    </article>
  );
}

export default function SeoPageCurriculum({ seoPage }) {
  const section = seoPage?.modules_section ?? seoPage?.curriculum_section;

  if (!section) return null;

  const rawItems = section.items ?? section.modules ?? [];

  if (!rawItems.length) return null;

  const modules = rawItems.map((item, i) => ({
    ...item,
    number: item.number ?? String(i + 1).padStart(2, "0"),
  }));

  const fullRowsCount = Math.floor(modules.length / 4) * 4;
  const gridItems = modules.slice(0, fullRowsCount);
  const lastRowItems = modules.slice(fullRowsCount);

  return (
    <section className="py-[56px] md:py-[80px] bg-[#F8FAFF]">
      <div className="max-w-[90%] mx-auto">
        <span className="inline-flex min-w-[140px] h-[28px] px-2 items-center justify-center rounded-full bg-[#DDECFF] text-[12px] font-[600] tracking-[0.08em] uppercase">
          <span className="bg-clip-text text-transparent bg-gradient-to-b from-[#091F59] to-[#1A3884]">
            {section.label ?? section.badge ?? "TƏDRİS PLANI"}
          </span>
        </span>

        <h2 className="mt-[16px] text-[#0A0A0A] text-[28px] md:text-[36px] font-[600] leading-[120%] max-w-[760px]">
          {section.heading ?? section.title}
        </h2>

        {section.subtitle && (
          <p className="mt-[12px] text-[#6A7282] text-[14px] md:text-[16px] leading-[140%] max-w-[760px]">
            {section.subtitle}
          </p>
        )}

        <div className="mt-[24px] grid grid-cols-1 gap-[12px] md:hidden">
          {modules.map((module, index) => (
            <ModuleCard key={`${module.number}-${index}`} module={module} />
          ))}
        </div>

        <div className="hidden md:block mt-[24px]">
          {gridItems.length > 0 && (
            <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-[16px]">
              {gridItems.map((module, index) => (
                <ModuleCard key={`${module.number}-${index}`} module={module} />
              ))}
            </div>
          )}

          {lastRowItems.length > 0 && (
            <div className="mt-[16px] flex items-center justify-center gap-[16px]">
              {lastRowItems.map((module, index) => (
                <div key={`${module.number}-${index}`} className="w-full md:w-[calc(50%-8px)] xl:w-[calc(25%-12px)]">
                  <ModuleCard module={module} />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
